import type { SemanticFaceMap } from './semanticFaceMap';

export const BEAUTY_SEGMENTATION_SCHEMA_VERSION = 'beautyiq-beauty-segmentation-v0.2';

export interface BeautySegmentationLabel {
  id: number;
  key: keyof SemanticFaceMap['masks'];
  label: string;
  tint: string;
  source: 'face-parsing' | 'landmark-derived' | 'beauty-procedural';
  targetClass: boolean;
}

export const BEAUTY_SEGMENTATION_LABELS: readonly BeautySegmentationLabel[] = [
  { id: 1, key: 'skin', label: 'Pelle', tint: '#f2b28a', source: 'face-parsing', targetClass: true },
  { id: 2, key: 'leftMobileLid', label: 'Palpebra S', tint: '#8f65ff', source: 'landmark-derived', targetClass: true },
  { id: 3, key: 'rightMobileLid', label: 'Palpebra D', tint: '#8f65ff', source: 'landmark-derived', targetClass: true },
  { id: 4, key: 'leftEye', label: 'Occhio S', tint: '#61a8ff', source: 'face-parsing', targetClass: true },
  { id: 5, key: 'rightEye', label: 'Occhio D', tint: '#61a8ff', source: 'face-parsing', targetClass: true },
  { id: 6, key: 'leftBrow', label: 'Sopracciglio S', tint: '#5c4033', source: 'face-parsing', targetClass: true },
  { id: 7, key: 'rightBrow', label: 'Sopracciglio D', tint: '#5c4033', source: 'face-parsing', targetClass: true },
  { id: 8, key: 'lips', label: 'Labbra', tint: '#d33b63', source: 'face-parsing', targetClass: true },
  { id: 9, key: 'leftCheek', label: 'Guancia S', tint: '#ef798a', source: 'landmark-derived', targetClass: true },
  { id: 10, key: 'rightCheek', label: 'Guancia D', tint: '#ef798a', source: 'landmark-derived', targetClass: true },
  { id: 11, key: 'leftCreaseFade', label: 'Sfumatura crease S', tint: '#b889ff', source: 'beauty-procedural', targetClass: true },
  { id: 12, key: 'rightCreaseFade', label: 'Sfumatura crease D', tint: '#b889ff', source: 'beauty-procedural', targetClass: true },
  { id: 13, key: 'leftLashLine', label: 'Lash line S', tint: '#2f211c', source: 'beauty-procedural', targetClass: true },
  { id: 14, key: 'rightLashLine', label: 'Lash line D', tint: '#2f211c', source: 'beauty-procedural', targetClass: true },
  { id: 15, key: 'lipBorder', label: 'Bordo labbra', tint: '#ff7f9a', source: 'beauty-procedural', targetClass: true },
  { id: 16, key: 'faceOval', label: 'Ovale viso', tint: '#f7d7bc', source: 'landmark-derived', targetClass: false }
];
